var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center",style:({height: _vm.errorPageHeight+'px'})},[_c('div',{staticClass:"col-12 col-md-8"},[_c('Empty')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }